// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessageProd(event, iframeId) {
  try {
    let dataObj = JSON.parse(event.data);
    if (dataObj && dataObj.eventType === 'listenerAttached') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    }
    if (dataObj.eventType === 'bookmark') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          eventData: dataObj.eventData,
        }),
        '*'
      );
    }

    if (dataObj.eventType === 'height') {
      document.getElementById(`${dataObj.eventData.frameId}`).style.height =
        dataObj.eventData.height;
    }

    if (dataObj.action === 'search') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          eventData: dataObj,
        }),
        '*'
      );
    }
  } catch (error) {}
}
class GevmeProduct extends HTMLElement {
  constructor() {
    super();
  }
  attachProductMessageEvent(iframeId) {
    window.addEventListener('message', (e) => {
      if (isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
        handleMessageProd(e, iframeId);
      }
    });
  }
  connectedCallback() {
    var iframe = document.createElement('iframe'),
      redirectBaseURI = `${
        window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
      }/widgets`,
      iframeSrc = '',
      objset = {},
      isContentBlock = false,
      frameHeight = '500px',
      settings = this.getAttribute('settings'),
      fullpagepreview = this.getAttribute('fullpagepreview'),
      iframeId = 'GevmeProduct-';

    try {
      // if JSON.parse fails then settings is a string not an object
      // in this case use the old format
      objset = JSON.parse(settings);
      iframeSrc =
        redirectBaseURI + '/product?s=' + encodeURI(JSON.stringify(objset));
      // frameHeight = objset && objset.height ? objset.height : "500px";
    } catch (error) {
      // in this case blockid was passed in settings attribute
      isContentBlock = true;
    }

    if (isContentBlock) {
      try {
        const passedId = settings;
        iframeId = iframeId + passedId
        const showcaseBlocks = Object.values(
          window.GEVME.livepage.showcaseblocks
        );

        const productBlock = showcaseBlocks.find(({ id }) => id === passedId);
        if (!productBlock) throw new Error('block not found');

        if (
          productBlock.blockHeight &&
          productBlock.blockHeight !== 'fit-content'
        )
          frameHeight = productBlock.blockHeight;

        iframeSrc =
          `${redirectBaseURI}/product?frameId=${iframeId}&projectId=${window?.GEVME?.project?.id}&companyId=${window?.GEVME?.project?.companyId}&livePageId=${window?.GEVME?.livepage?.id}&blockId=${passedId}` +
          `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}` +
          (fullpagepreview
            ? `&previewInXP=${
                fullpagepreview === 'true' || fullpagepreview === 'undefined'
                  ? 'false'
                  : 'true'
              }`
            : '') +
          `&slug=${window?.GEVME?.livepage?.slug}`;
      } catch (error) {
        console.error(error);
      }

      iframe.id = iframeId;
      iframe.name = 'GevmeProduct';
      iframe.title = 'Gevme Product';
      iframe.sandbox =
        'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
      iframe.allowFullScreen = true;
      iframe.seamless = true;
      iframe.loading = 'lazy';
      iframe.frameBorder = '0';
      iframe.referrerPolicy = 'no-referrer';
      iframe.src = iframeSrc;
      iframe.style = `display: flex; width: ${
        objset && objset.width ? objset.width : '100%'
      }; height: ${frameHeight}; margin: auto;`;
      // overflow: hidden;
      this.append(iframe);
      this.attachProductMessageEvent(iframeId);
    }

    iframe.id = iframeId;
    iframe.name = 'GevmeProduct';
    iframe.title = 'Gevme Product';
    iframe.sandbox =
      'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = 'lazy';
    iframe.frameBorder = '0';
    iframe.referrerPolicy = 'no-referrer';
    iframe.src = iframeSrc;
    iframe.style = `display: flex; width: ${
      objset && objset.width ? objset.width : '100%'
    }; height: ${frameHeight}; margin: auto;`;
    // overflow: hidden;
    iframe.onload = function () {
      try {
        this.contentWindow.postMessage(
          JSON.stringify({
            action: 'gevme-json',
            data: JSON.stringify(window.GEVME),
          }),
          '*'
        );
      } catch (error) {}
    };
    this.append(iframe);
    this.attachProductMessageEvent(iframeId);
  }
}
window.customElements.define('gevme-product', GevmeProduct);
